import { useDispatch } from 'react-redux';
import { setUserData } from '../../redux/slices/authSlice';
import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { GoogleUser } from '../../utils/types';
import { useNavigate } from 'react-router';
import { CircularProgress } from '@mui/material';

function AuthLogin() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [storedUser, setStoredUser] = useState<GoogleUser | null>(null);

    useEffect(() => {
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const idToken = hashParams.get('id_token');

        // If there's an id_token in the URL, decode it and set the user
        // Otherwise, check localStorage for a stored user
        if (hashParams.get('error')) {
            console.error('Error during authentication:', hashParams.get('error'));
            navigate('/autenticacion-usuario');
            return;
        }

        if (idToken) {
            const user = jwtDecode<GoogleUser>(idToken);
            setStoredUser(user);
            dispatch(setUserData(user));
            localStorage.setItem('id_token', idToken);
            localStorage.setItem('user', JSON.stringify(user));
        } else {
            const stored = localStorage.getItem('user');
            if (stored) {
                const user = JSON.parse(stored);
                setStoredUser(user);
                dispatch(setUserData(user));
            }
        }

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (storedUser && storedUser.name) {
            navigate('/app', { replace: true });
        }
        // eslint-disable-next-line
    }, [storedUser]);

    return <CircularProgress style={{ position: 'absolute', top: '50%', left: '50%' }} />;
}

export default AuthLogin;
